<span class="clip3 position-relative user-card primary-text-100 primary-border corner p-2">
    <ng-content select="[button-1]"></ng-content>
    <span class="mx-2 h-divider"></span>

    <ng-content select="[button-2]"></ng-content>
    <span class="mx-2 h-divider"></span>

    <ng-content select="[button-3]"></ng-content>
    <span class="mx-2 h-divider"></span>

    <ng-content select="[button-4]"></ng-content>
    
</span>
